import apiClient from "../api/axiosConfig";

export const getStates = async (countryISO3Code) =>
    apiClient.feesAPI.get(`/api/states/getStatesList/${countryISO3Code}`);
